parentType